<template>
    <div>
       <div class="header-img" v-if="img_src">
           <img :src="img_src" @click="showTop = true"/>
            <van-image-preview v-model="showTop" :images="[img_src]" :showIndex="false">
            </van-image-preview>
       </div>
        <div class="timeTabs-wrap">
				<div class="timeTabs">
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''">
						{{item}}
					</div>
				</div>			
		</div>
        <div class="content">
            <ul class="leftC">
                <li class="item" v-for="(item,index) in scheduleList" :key="index">
                  {{item.name}}
                </li>
            </ul>
            <div class="rightC">
                <div class="sessionList">
                    <div class="list" v-for="(value,index) in scheduleList" :key="index">
                        <router-link class="item" v-for="(val,ind) in value.chapters" :key="ind" :to="{path:'/meeting/scheduleDetails',query:{chapter_id:val.id,meeting_id:meeting_id}}">
                            <h1>{{val.start_at}}-{{val.end_at}}</h1>
                            <div>
                                <p class="line-clamp-3">{{val.name}}</p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Footer from "@/components/Footer.vue"
import {MeetingsSchedule} from "../../config/interface.js"
export default {
    data(){
        return{
            meeting_id:0,
            active:0,
            meetingSchedule:[],    //会议日程
            scheduleDate:[],     //会议日期
            scheduleList:[],       //日期对应的日程列表
            img_src:'',
            showTop:false
        }
    },
    mounted(){
        this.meeting_id=this.$route.query.id;
        this.getSchedule();
        
    },
    methods:{
        getSchedule(){
            const url=MeetingsSchedule;
            let params={
                meeting_id:this.meeting_id,

            }
            const method="POST";
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    var data=res.data;
                    this.meetingSchedule=data.sessions;
                    this.img_src=data.meeting.schedule_center_img;
                    this.scheduleDate=Object.keys(this.meetingSchedule);
                    for(var i in this.meetingSchedule){
                        this.meetingSchedule[i].forEach((item,suffix)=>{
                            item.chapters.forEach((value,index)=>{
                                value.start_at=this.handleDate(value.start_at);
                                value.end_at=this.handleDate(value.end_at);

                            })

                            
                        })
                    }
                    this.switchDate(this.scheduleDate[0]);
                   
                    
                }
            })
        },
        //切换日期
        switchDate(date){
            this.active=date;
            this.scheduleList=this.meetingSchedule[date];
            
        },
        //处理日期  09:30样式
        handleDate(date){
            let time=(date.split(' ')[1]).split(':')
            return time[0]+':'+time[1];
        }
    }
}
</script>
<style lang="scss" scoped>
.header-img{
    img{
        width: 100%;
        display: block;
    }
    // height: 70px;
}
    .timeTabs-wrap{
			overflow:hidden;
			width:100%;
			background:#fff;
		
	}
    .timeTabs{
			padding:0 12px;
			height:60px;
			@include flex(row);
			align-items: center;
			overflow:auto;
			width:100%;
			border-bottom:1px solid #bfbfbf;
			.tab-item{
				font-size:14px;
				color:#666;
				width:70px;
				height:30px;
				text-align:center;
				line-height:30px;
				border:1px solid #666;
				border-radius:2px;
				margin-right:15px;
			}
			.active{
				color:#fff;
				background:#B3292C;
				border:0px;
			}
		}
    .content{
         padding:15px 0;
         background-color:#f1f2f4;
         height:calc(100vh - 110px);
         overflow:auto;
        .leftC{
            float:left;
            width:27%;
            padding:0 12px;
            .item{
                padding:5px; /* no */
                @include line-clamp-n(4);
                box-sizing: border-box;
                width: 77px;
                background: #FFFFFF;
                border-radius: 3px;
                height: 94px;
                // display:flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 14px;  /* no */
                letter-spacing: 0.5px;
                color: #090909;
                margin-bottom:15px;
            }
        }
        .rightC{
            overflow-x:auto;
            float:left;
            width:73%;
            .list{
                display: -webkit-box;
            }
            .item{
                display: block;
                box-sizing: border-box;
                background: #B3292C;
                border-radius: 3px;
                width:110px;
                height:94px;
                padding:6px;
                margin:0 5px 15px 0;
                h1{
                    font-weight:normal;
                    text-align: center;
                    font-size: 12px;
                    color: #FFFFFF;
                    letter-spacing: 0.42px;
                }
                div{       
                    padding:5px;
                    border-radius:3px;
                    background:#fff;
                    margin-top:6px;
                    height:60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p{
                        word-break: break-all;
                        font-size: 12px;
                        color: #626262;
                        letter-spacing: 0.42px;
                    }
                }
            }
        }
        
    }
    .content:after{
            display:block;
            content:'';
            clear:both;
        }


</style>


// WEBPACK FOOTER //
// src/pages/meeting/schedule.vue